export const dateformat: string = "dd-MMM-yy";

export const projectRoles: { roleId: number, roleName: string }[] = [
    { roleId: 1, roleName: "Viewer" },
    { roleId: 2, roleName: "Team Member" },
    { roleId: 3, roleName: "Sponsor" },
    { roleId: 4, roleName: "Project Manager" },
];

export const projectTypes: { typeId: number, typeName: string }[] = [
    { typeId: 1, typeName: "Simple Project" },
    { typeId: 2, typeName: "With Workstreams" },
];

export function isWorkingDay(date: Date): boolean {
    return date.getDay() !== 0 && date.getDay() !== 6;
}